import { useEffect } from 'react';

import { closeWsConnection } from 'common/apollo/PhoenixSocketHelper';
import useDialog from 'common/components/core/DialogProvider/useDialog';
import { useEvent } from 'common/components/hooks/useEvent/useEvent';
import { usePollingContextActions } from 'common/components/withPollingContext/usePollingContextActions';

import { NewVersionDialog } from './NewVersionDialog';
import { swRegistrationSubject, SwRegistrationSubjectState } from './swRegistrationSubject';

export function useAppVersionWatcher() {
  const { openDialog } = useDialog();
  const { stopPolling } = usePollingContextActions();

  const onNewAppVersion = useEvent((reg: ServiceWorkerRegistration) => {
    stopPolling();
    closeWsConnection();
    openDialog(NewVersionDialog, {
      onReload: () => reg.waiting?.postMessage({ type: 'SKIP_WAITING' }),
    });
  });

  useEffect(() => {
    const sub = swRegistrationSubject.subscribe(value => {
      if (value.registration && value.state === SwRegistrationSubjectState.UPDATE) {
        if (value.registration.waiting) {
          onNewAppVersion(value.registration);
        }
      }
    });

    return () => {
      sub.unsubscribe();
    };
  }, [onNewAppVersion]);
}
